// Drag bar and dots under a swipeable row. Reads its options off the element,
// so a row that arrives later (the recommendations block fetches its own
// markup) is picked up as well.
(function () {
  var MIN_THUMB = 24;

  function setup(root) {
    if (root.dataset.pagerReady) return;
    var slider = document.getElementById(root.dataset.slider);
    if (!slider) return;
    root.dataset.pagerReady = '1';

    var track = root.querySelector('[data-pager-track]');
    var thumb = root.querySelector('[data-pager-thumb]');
    var dots = root.querySelector('[data-pager-dots]');
    var reveal = root.dataset.reveal === 'hover';
    var linger = parseInt(root.dataset.linger, 10) || 900;

    function pages() {
      return Math.max(1, Math.round(slider.scrollWidth / slider.clientWidth));
    }
    function maxScroll() {
      return Math.max(1, slider.scrollWidth - slider.clientWidth);
    }
    function buildDots() {
      if (!dots || dots.children.length === pages()) return;
      dots.innerHTML = '';
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = root.className.split(' ')[0] + '__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (n) {
          b.addEventListener('click', function () {
            slider.scrollTo({ left: n * slider.clientWidth, behavior: 'smooth' });
          });
        })(i);
        dots.appendChild(b);
      }
    }
    function render() {
      var ratio = slider.scrollLeft / maxScroll();
      if (thumb && track) {
        var w = Math.max(MIN_THUMB, track.clientWidth * (slider.clientWidth / slider.scrollWidth));
        thumb.style.width = w + 'px';
        thumb.style.transform = 'translateX(' + ratio * (track.clientWidth - w) + 'px)';
      }
      if (dots) {
        buildDots();
        var active = Math.round(slider.scrollLeft / slider.clientWidth);
        [].forEach.call(dots.children, function (d, i) {
          d.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
      }
    }

    if (track) {
      var dragging = false;
      var seek = function (clientX) {
        var r = track.getBoundingClientRect();
        var w = Math.max(MIN_THUMB, r.width * (slider.clientWidth / slider.scrollWidth));
        var p = (clientX - r.left - w / 2) / Math.max(1, r.width - w);
        slider.scrollLeft = Math.min(1, Math.max(0, p)) * maxScroll();
      };
      track.addEventListener('pointerdown', function (e) {
        dragging = true;
        track.setPointerCapture(e.pointerId);
        seek(e.clientX);
      });
      track.addEventListener('pointermove', function (e) {
        if (dragging) seek(e.clientX);
      });
      track.addEventListener('pointerup', function () { dragging = false; });
      track.addEventListener('pointercancel', function () { dragging = false; });
    }

    if (reveal) {
      var hideTimer;
      var flash = function () {
        root.classList.add('is-scrolling');
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
          root.classList.remove('is-scrolling');
        }, linger);
      };
      slider.addEventListener('scroll', flash, { passive: true });
      slider.addEventListener('touchstart', flash, { passive: true });
    }

    slider.addEventListener('scroll', render, { passive: true });
    window.addEventListener('resize', render);
    render();
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-fc-pager]').forEach(setup);
  }

  scan();
  document.addEventListener('DOMContentLoaded', function () { scan(); });
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      for (var j = 0; j < records[i].addedNodes.length; j++) {
        var n = records[i].addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('[data-fc-pager]')) setup(n);
        else scan(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
